module.exports = __webpack_public_path__ + "static/media/tv.829fb9d8.svg";